export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // Master Data Group
  'menu.masterData': 'Master Data',
  'menu.masterData.brand': 'Brand',
  'menu.masterData.color': 'Color',
  'menu.masterData.currency': 'Currency',
  'menu.masterData.origin': 'Origin',
  'menu.masterData.size': 'Size',
  'menu.masterData.uom': 'Unit of Measure',
  'menu.masterData.site': 'Site',
  'menu.masterData.accountGroup': 'Account Group',
  'menu.masterData.jobPosition': 'Job Position',
  'menu.masterData.lightSource': 'Light Source',
  'menu.masterData.section': 'Section',
  'menu.masterData.catalogPath': 'Catalog Path',

  // Organization Group
  'menu.organization': 'Organization',
  'menu.organization.organization': 'Organization',
  'menu.organization.organizationDetail': 'Organization Detail',
  'menu.organization.address': 'Address',
  'menu.organization.addressDetail': 'Address Detail',

  // Production Group
  'menu.production': 'Production',
  'menu.production.line': 'Line',
  'menu.production.lineType': 'Line Type',
  'menu.production.machine': 'Machine',
  'menu.production.machineType': 'Machine Type',
  'menu.production.operationLibrary': 'Operation Library',
  'menu.production.operationLibraryDetail': 'Operation Library Detail',
  'menu.production.componentGroup': 'Component Group',
  'menu.production.component': 'Component',

  // Business Partners Group
  'menu.businessPartners': 'Business Partners',
  'menu.businessPartners.customer': 'Customer',
  'menu.businessPartners.customerType': 'Customer Type',
  'menu.businessPartners.supplier': 'Supplier',
  'menu.businessPartners.supplierType': 'Supplier Type',

  // Product Management Group
  'menu.productManagement': 'Product Management',
  'menu.productManagement.product': 'Product',
  'menu.productManagement.productType': 'Product Type',
  'menu.productManagement.category': 'Category',
  'menu.productManagement.productGroup': 'Product Group',
  'menu.productManagement.productCategory': 'Product Category',
  'menu.productManagement.subCategory': 'Sub Category',
  'menu.productManagement.materialType': 'Material Type',

  // Human Resources Group
  'menu.humanResources': 'Human Resources',
  'menu.humanResources.employee': 'Employee',
  'menu.humanResources.employeeType': 'Employee Type',
  'menu.humanResources.calendar': 'Calendar',
  'menu.humanResources.calendarCustomize': 'Calendar Customize',
  'menu.humanResources.holiday': 'Holiday',

  // Shipping & Logistics Group
  'menu.shippingLogistics': 'Shipping & Logistics',
  'menu.shippingLogistics.port': 'Port',
  'menu.shippingLogistics.deliveryTerm': 'Delivery Term',
  'menu.shippingLogistics.shipmentTerm': 'Shipment Term',
  'menu.shippingLogistics.paymentTerm': 'Payment Term',

  // Legacy menu items (keeping for backward compatibility)
  'menu.list': 'List (Legacy)',
  'menu.list.organization': 'Organization',
  'menu.list.organizationDetail': 'Organization Detail',
  'menu.list.operationLibraryDetail': 'Operation Library Detail',
  'menu.list.addressDetail': 'Address Detail',
  'menu.list.accountGroup': 'Account Group',
  'menu.list.jobPosition': 'Job Position',
  'menu.list.section': 'Section',
  'menu.list.color': 'Color',
  'menu.list.currency': 'Currency',
  'menu.list.customer': 'Customer',
  'menu.list.customerType': 'Customer Type',
  'menu.list.address': 'Address',
  'menu.list.calendarCustomize': 'Calendar Customize',
  'menu.list.calendar': 'Calendar',
  'menu.list.brand': 'Brand',
  'menu.list.deliveryTerm': 'Delivery Term',
  'menu.list.employee': 'Employee',
  'menu.list.costCategory': 'Cost Category',
  'menu.list.costItem': 'Cost Item',

  'menu.business': 'Business',
  'menu.business.plan': 'Plan',
  'menu.business.costRequest': 'Cost Request',

  'menu.reports': 'Reports',
  'menu.reports.organization': 'By Organization',
  'menu.reports.costItem': 'By Cost Item',
  'menu.reports.summary': 'Summary',

  'menu.admin': 'Admin',
};
